import {
  AUTHENTICATION_SUCCESS,
  AUTHENTICATION_INVALIDATE,
  LOGOUT_SUCCESS
} from '../actions/api/auth';
import { SET_WELCOME, RESET_NEWLY_AUTHENTICATED } from '../actions/session';
import api from '../store/config/api';
import file from '../store/config/file';
import userSessionCookie from '../store/config/userSessionCookie';
import { ACCEPT_INVITE_SUCCESS } from '../actions/api/invite';
import {
  GET_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  UNLOCK_USER_SUCCESS
} from '../actions/api/user';
import { getKey, setKey } from '../util/session';

const USER_SESSION_INTIALIZE = userSessionCookie.INITIALIZE;

function setUserSession(user) {
  const defaultKey = getKey();
  const { userKey = defaultKey, teamName } = user; // eslint-disable-line no-unused-vars

  // TODO Pull these out once users are moved over to session auth via catalytic-web
  api.update({ headers: { 'x-user-key': userKey } });
  file.update({ headers: { 'x-user-key': userKey } });
  if (userKey && userKey !== defaultKey) setKey(userKey);
}

export default function session(state = {}, action) {
  switch (action.type) {
    case AUTHENTICATION_SUCCESS:
      const {
        type, // eslint-disable-line no-unused-vars
        response: { entities: { users }, result: userID } = {}
      } = action;
      const { isWelcome } = state;
      const user = users[userID];
      const {
        userKey,
        teamName,
        username,
        fullName,
        email,
        isTeamAdmin,
        isTeamOwner,
        userThumbnail,
        experience
      } = user;

      setUserSession(user);

      return {
        userKey,
        username,
        fullName,
        teamName,
        userID,
        email,
        isTeamAdmin,
        isTeamOwner,
        userThumbnail,
        isWelcome,
        experience,
        newlyAuthenticated: true
      };
    case ACCEPT_INVITE_SUCCESS:
      return (() => {
        const {
          type, // eslint-disable-line no-unused-vars
          response: { entities: { invites }, result: inviteID } = {}
        } = action;
        const { isWelcome } = state;
        const user = invites[inviteID];
        const {
          userKey,
          teamName,
          username,
          fullName,
          email,
          isTeamAdmin,
          isTeamOwner,
          userThumbnail,
          userID,
          experience
        } = user;

        setUserSession(user);

        return {
          userKey,
          username,
          fullName,
          teamName,
          userID,
          email,
          isTeamAdmin,
          isTeamOwner,
          userThumbnail,
          isWelcome,
          experience
        };
      })();
    case USER_SESSION_INTIALIZE:
      return (() => {
        const { userKey, teamName, username, isWelcome } = state; // eslint-disable-line no-unused-vars
        setUserSession(state);
        return {
          ...state,
          newlyAuthenticatedSSO: true
        };
      })();

    case LOGOUT_SUCCESS:
    case AUTHENTICATION_INVALIDATE:
      return {};

    case SET_WELCOME:
      return {
        ...state,
        isWelcome: action.isWelcome
      };

    case RESET_NEWLY_AUTHENTICATED:
      return {
        ...state,
        newlyAuthenticated: false,
        newlyAuthenticatedSSO: false
      };

    case GET_USER_SUCCESS:
    case UPDATE_USER_SUCCESS:
    case UNLOCK_USER_SUCCESS:
      return (() => {
        const {
          response: { entities: { users }, result: userID } = {}
        } = action;
        if (state.userID !== userID) {
          return state;
        }
        const user = users[userID];
        const { experience } = user;

        return {
          ...state,
          experience
        };
      })();

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/session.js